import PropTypes from 'prop-types';
import React from 'react';

class RangeGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.value };
    this.handleChange = this.handleChange.bind(this);
    this._ref = React.createRef();
  }

  handleChange(e) {
    let value = e.target.value;
    this.props.onChange(e);
    this.setState({value});
  }

  render() {
    const {id, min, max, name, step, type} = this.props;
    const {value} = this.state;
    let symbol = (this.props.symbol) ? this.props.symbol : '';

    return (
      <div className='control__input range-group' ref={this._ref} type='range-group'>
        <input
          className='range-group__range'
          id={id}
          min={min}
          max={max}
          name={name}
          onChange={this.handleChange}
          step={step}
          type={type}
          value={value}
        />
        <output
          aria-hidden='true'
          className='range-group__tooltip'
          htmlFor={id}
        >
          {`${value}${symbol}`}
        </output>
      </div>
    );
  }

  componentDidMount() {
    this._setRangeCSSVariables();
    this._updateTooltipPosition();

    function updateRange() {
      this._setRangeCSSVariables.call(this);
      this._updateTooltipPosition.call(this);
    }

    /* Repositions tooltip when RangeGroup width changes on resize or submit event*/
    window.addEventListener('submit', () => setTimeout(updateRange.bind(this), 300));
    window.addEventListener('resize', () => updateRange.bind(this));
  }

  componentDidUpdate() {
    const node = this._ref.current;
    const {value} = this.state;

    node.style.setProperty('--val', value);

    this._updateTooltipPosition();
  }

  _setRangeCSSVariables() {
    const node = this._ref.current;
    const {min, max} = this.props;
    const {value} = this.state;

    node.style.setProperty('--val', value);
    node.style.setProperty('--min', min);
    node.style.setProperty('--max', max);
  }

  _updateTooltipPosition() {
    const node = this._ref.current;
    const style = window.getComputedStyle(node);
    const {min, max} = this.props;
    const value = +this.state.value;
    const width = +style.getPropertyValue('width').replace('px', '');
    const diameter = +style.getPropertyValue('--rangeslider--thumb-diameter').replace('px', '');
    const translateX = (value - min) / (max - min) * (width - diameter);

    node.style.setProperty('--translateX', translateX + 'px');
  }
}

RangeGroup.propTypes = {
  id: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  step: PropTypes.number,
  symbol: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.number
};

export default RangeGroup;
